import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Legend, LoaderWrapper, ReportHeading, MuiButton, ReportOuterWrapper, GraphGridTab } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import ComparisonTable from './comparisonTable'
import { ContentWrap, RootWrap } from './style'
import { getObjectAsArray, sortByKey, exportExcel_addSegments } from '../../../../util'
import { useGlobalStore } from '../../../../store'
import CONFIG from './config'
import PercentSplitGraph from './percentSplit'
import { IconArrowDown, IconArrowUpBig } from '../../../../assets/images/icons'

const ComparisonViewDeepDiveV2 = (props) => {
  const [state, setState] = useState([])
  const [segmentData, setSegmentData] = useState(null)
  const [reportData, setReportData] = useState([])
  const [maxValue, setMaxValue] = useState(100)
  const [activeTab, setActiveTab] = useState(0)
  const [driversExcelData, setDriversExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [legendsData, setLegendsData] = useState([
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ])
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [periodInOrder, setPeriodInOrder] = useState()
  const [eventCount, setEventCount] = useState(1)
  const { isPPTModalActive } = useGlobalStore()

  const [showTableGrid, setShowTableGrid] = useState('graph')

  const getData = (dd, field = 'SegmentDrivers', isInner = true) => {
    const obj = {}
    const percentArr = []
    for (let index = 0; index < dd?.length; index++) {
      const element = dd[index]
      const driverElement = element?.[field]?.DriverElement
      const drivers = Array.isArray(driverElement)
        ? driverElement
        : Object.keys(driverElement || {})?.length
          ? [driverElement]
          : []

      for (let j = 0; j < drivers.length; j++) {
        const innerElement = drivers[j]
        const key = innerElement.DriverName

        const associationData = [
          {
            SearchKeywords: innerElement.Percent,
          },
        ]

        const multiBarData = [
          {
            Positive: innerElement.PositivePercent,
            Neutral: innerElement.NeutralPercent,
            Mixed: innerElement.MixedPercent,
            Negative: innerElement.NegativePercent
          }
        ]

        let keyName = isInner ? innerElement.TargetSegment : element.PeriodName
        // if ( ['Triangulation', 'TriangulationComparisonViewOnly'].includes(props?.InsightsElementType) ) {
        //   keyName = element.TriangulationSubName
        // }

        obj[key] = {
          ...(obj[key] || {}),
          [keyName]: {
            ...innerElement,
            data: CONFIG[props.InsightsElementType]?.type ? associationData : multiBarData,
          },
        }

        percentArr.push(innerElement.Percent)
      }
    }
    setMaxValue(Math.max(...percentArr))
    return obj
  }

  const updateExcelData = (data) => {
    const arr = { drivers: [], attributes: [], subAttributes: [] }
    const objArr1 = Object.keys(data)
    for (let i = 0; i < objArr1.length; i++) {
      const name1 = objArr1[i]
      const objArr2 = Object.keys(data[name1])
      for (let j = 0; j < objArr2.length; j++) {
        const name2 = objArr2[j]
        const obj = data[name1][name2]
        arr.drivers.push([
          { value: name1 },
          { value: name2 },
          ...exportExcel_addSegments(obj, true),
        ])
        const driverAttri = getObjectAsArray(obj?.DriverAttributes?.DriverAttributeElement || [])
        for (let k = 0; k < driverAttri.length; k++) {
          arr.attributes.push([
            { value: name1 },
            { value: name2 },
            { value: driverAttri[k].AttributeName },
            ...exportExcel_addSegments(driverAttri[k], true),
          ])
          let subDriverAttri = getObjectAsArray(
            driverAttri[k]?.DriverSubAttributes?.DriverSubAttributeElement || []
          )
          for (let m = 0; m < subDriverAttri.length; m++) {
            arr.subAttributes.push([
              { value: name1 },
              { value: name2 },
              { value: driverAttri[k].AttributeName },
              { value: subDriverAttri[m].SubAttributeName },
              ...exportExcel_addSegments(subDriverAttri[m], true),
            ])
          }
        }
      }
    }
    setDriversExcelData(arr)
  }

  const hasTabs = props.isDriversProgression
  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'driverProgression'],
      urlFunc: hasTabs
        ? ReportsService.getDriverProgressionElement
        : ReportsService.GetSegmentDriversAnalysisWithDeepDiveElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } =
    useReactQuery(useReactQueryObject1)

  const expandCollapseFunc = (flag) => {
    setExpandedStatus(flag)
  }

  useEffect(() => {
    if (props?.driversSegmentsExpanded) {
      setExpandedStatus(true)
    }
  }, [props?.driversSegmentsExpanded])

  useEffect(() => {
    setEventCount((p) => p + 1)
  }, [state, segmentData, expandedStatus])

  const AdditionalButtons = ({ expandedStatus, expandCollapseFunc, expanded, showTableGrid, setShowTableGrid }) => {
    return (
      <>
        <GraphGridTab show={showTableGrid} onClick={(p) => setShowTableGrid(p)} />
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={expandedStatus ? <IconArrowUpBig /> : <IconArrowDown />}
          onClick={() => expandCollapseFunc(!expandedStatus)}
        >
          {expandedStatus ? 'Collapse All' : 'Expand All'}
        </MuiButton>
      </>
    )
  }

  const onSuccessFunc = (resp) => {
    const orderedData = sortByKey(getObjectAsArray(resp), 'PeriodOrder').map((d) => d.PeriodName)
    setPeriodInOrder(orderedData)
    if (hasTabs) {
      const sd = getData(resp, 'PeriodDrivers', false)
      setSegmentData(sd)
      updateExcelData(sd)

      const dd = resp.map((item) => ({
        ...item,
        SegmentDrivers: item.PeriodDrivers,
      }))
      setReportData(dd)
      updateSubLhsApiLoaded(props)
      setEventCount((p) => p + 1)
    } else {
      const averageStarRating = resp.map((item) => {
        return {
          SegmentType: item.SegmentType,
          SegmentName: item.SegmentName,
          SegmentMaxValue: item.SegmentMaxValue,
          SegmentValue: item.SegmentValue,
          type: 'Association',
          data: [
            {
              0: item.SegmentValue,
            },
          ],
        }
      })
      setState([
        {
          SegmentType: averageStarRating[0]?.SegmentType,
          data: averageStarRating,
          id: `percentGraph_${props.InsightsElementId.replaceAll('-','')}`
        },
      ])

      const sd = getData(resp)
      setSegmentData(sd)
      updateExcelData(sd)

      setReportData(resp)
      // updateSubLhsApiLoaded(props)
      setEventCount((p) => p + 1)
    }
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  useEffect(() => {
    // if (isPPTModalActive && state?.length > 0 && !['SegmentDriversOnlyAnalysis3Level'].includes(props?.InsightsElementType)) {
    if (isPPTModalActive && state?.length > 0) {
      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      },1000)
    }
  }, [isPPTModalActive, state])

  return (
    <>
      {state && segmentData && driversExcelData && (
        <ReportHeading
          resetInsightHeight={eventCount+activeTab}
          downloadId={props.type}
          downloadIdData={driversExcelData}
          pptData={{data:{percentSplit:state?.[0] || [], segmentData:segmentData}, settings:{}}}
          {...props}
          additionalButton={
            <AdditionalButtons
              expandedStatus={expandedStatus}
              expandCollapseFunc={expandCollapseFunc}
              expanded={expandedStatus}
              showTableGrid={showTableGrid}
              setShowTableGrid={setShowTableGrid}
            />
          }
          addTable={true}
        />
      )}
    {isPPTModalActive && state?.length > 0 && !['SegmentDriversOnlyAnalysis3Level', 'SegmentDriversOnlyAnalysisWithoutSentiments3Level'].includes(props?.InsightsElementType) && <PercentSplitGraph data={state} />}
      <ReportOuterWrapper type={props?.InsightsElementType}>
        <RootWrap id={props.type} className={`${props.InsightsElementType}`}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            {!!Object?.keys(segmentData || {})?.length && (
              <>
                <ContentWrap className='segmentWrapper'>
                  <ComparisonTable
                    // keyOrdering={reportData.map(d => ({PeriodName: d.PeriodName, PeriodOrder: d.PeriodOrder}))}
                    keyOrdering={reportData.map((d) => d?.PeriodName || d?.SegmentName)}
                    isSearchDrivers={props.isSearchDrivers}
                    maxValue={maxValue}
                    data={state}
                    segmentData={segmentData}
                    type={CONFIG[props.InsightsElementType]?.type}
                    filterType={CONFIG[props.InsightsElementType]?.filterType}
                    insightsElementType={props.InsightsElementType}
                    expanded={expandedStatus}
                    filterUpdated={() => setEventCount((p) => p + 1)}
                    periodInOrder={periodInOrder}
                    // isSegmentsComponent={isSegmentsComponent}
                    showTableGrid={showTableGrid}
                  />
                </ContentWrap>
                {CONFIG[props?.InsightsElementType]?.showLegends && (
                  <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '30px' }}>
                    <Legend legends={legendsData} />
                  </Box>
                )}
              </>
            )}
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default ComparisonViewDeepDiveV2
